import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "status-buttons" }
const _hoisted_4 = { style: {"margin-top":"20px"} }
const _hoisted_5 = { class: "t6_table_b" }
const _hoisted_6 = { class: "td_center" }
const _hoisted_7 = {
  key: 0,
  class: "pagination"
}
const _hoisted_8 = { class: "detail-container" }
const _hoisted_9 = { class: "detail-table" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "dialog-footer" }

import { reactive, ref, onMounted } from 'vue';
import { cloudExplorationList } from '@/config/request';
import { ElMessage, ElDialog } from 'element-plus';
import { useStore } from "vuex";

interface ExplorationItem {
    id: string;
    servicename: string;
    status: string;
    createTime: string;
    roomId: string;
    // 新增详情字段
    projid?: string;
    applyname?: string;
    applyCardnumber?: string;
    legalman?: string;
    applyTelephone?: string;
    applyIdCard?: string;
    contactman?: string;
    telphone?: string;
    contactmanCardnumber?: string;
    servicecode?: string;
    servicename?: string;
    realName?: string;
    appointmentTime?: string;
    address?: string;
    tips?: string;
}

// 状态管理

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()

const data = reactive({
  userInfo: {} as any,
})

const paginate = reactive({
    pageNo: 1,
    pageSize: 10,
    pageSizes: [5,10,20],
    total: 0,
})
data.userInfo = store.state.userInfomation

// 定义接口返回数据类型，增加详情所需字段
const activeTab = ref('待勘验');
const loading = ref(false);
const explorationList = ref<ExplorationItem[]>([]);
// 新增弹窗相关状态
const dialogVisible = ref(false);
const currentExploration = ref<ExplorationItem | null>(null);

/**
 * 获取勘探列表数据
 */
const getExplorationList = async () => {
    try {
        loading.value = true;
        let params = {
            applyCardnumber: data.userInfo.certificateSno || data.userInfo.certNo,
            status: activeTab.value,
            pageNo: paginate.pageNo,
            pageSize: paginate.pageSize
        };
        const response = await cloudExplorationList(params);

        if (response.success) {
            explorationList.value = response.result.records || [];
            paginate.total = response.result.total || 0;
        } else {
            ElMessage.error('获取勘探列表失败: ' + (response.message || '未知错误'));
        }
    } catch (error) {
        console.error('获取勘探列表异常:', error);
        ElMessage.error('获取数据失败，请重试');
    } finally {
        loading.value = false;
    }
};

/**
 * 显示详情弹窗
 */
const showDetail = (item: ExplorationItem) => {
    currentExploration.value = item;
    dialogVisible.value = true;
};

/**
 * 关闭弹窗时的处理
 */
const handleClose = () => {
    dialogVisible.value = false;
};

/**
 * 切换勘验状态
 */
const changeStatus = (status: string) => {
    activeTab.value = status;
    paginate.pageNo = 1; // 切换状态时重置页码
    getExplorationList();
};

// 移除原有的handleTabClick函数

/**
 * 进入勘探
 */
const gotoExploration = (item: ExplorationItem) => {
    // 这里可以跳转到勘探页面或打开勘探对话框
    console.log('进入勘探:', item);
    // 示例：window.open(`/vr-exploration?roomId=${item.roomId}`);
    ElMessage.success('即将进入勘探: ' + item.projectName);
};

/**
 * 分页页码变化处理
 */
const handleCurrentChange = (index: number) => {
    paginate.pageNo = index;
    getExplorationList();
};

/**
 * 分页大小变化处理
 */
const handleSizeChange = (size: number) => {
    paginate.pageSize = size;
    paginate.pageNo = 1; // 改变每页大小时重置页码为1
    getExplorationList();
};

// 页面加载时获取数据
onMounted(() => {
    getExplorationList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_loading = _resolveComponent("el-loading")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "t6_title_h1" }, "零跑智勘", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: _normalizeClass({ 'active-btn': activeTab.value === '待勘验' }),
          size: "default",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeStatus('待勘验')))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" 待勘验 ", -1)
          ]))]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_button, {
          class: _normalizeClass({ 'active-btn': activeTab.value === '已勘验' }),
          size: "default",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeStatus('已勘验')))
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" 已勘验 ", -1)
          ]))]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { width: "500" }, "事项名称"),
              _createElementVNode("th", { width: "200" }, "申请时间"),
              _createElementVNode("th", { class: "td_center" }, "操作")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(explorationList.value, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [
                _createElementVNode("td", null, _toDisplayString(item.servicename), 1),
                _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (showDetail(item))
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("详情", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]),
        (explorationList.value.length === 0 && !loading.value)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "暂无数据"
            }))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createBlock(_component_el_loading, {
              key: 1,
              text: '加载中...',
              fullscreen: ""
            }))
          : _createCommentVNode("", true)
      ]),
      (paginate.total > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_el_pagination, {
              background: "",
              onCurrentChange: handleCurrentChange,
              onSizeChange: handleSizeChange,
              layout: "sizes, prev, pager, next, ->, total",
              "page-size": paginate.pageSize,
              "page-sizes": paginate.pageSizes,
              total: paginate.total
            }, null, 8, ["page-size", "page-sizes", "total"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "勘探详情",
      width: '55%',
      "before-close": handleClose,
      "close-on-click-modal": true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_25, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "label" }, "业务编号", -1)),
              _createElementVNode("td", _hoisted_10, _toDisplayString(currentExploration.value.projid), 1),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "label" }, "企业名称", -1)),
              _createElementVNode("td", _hoisted_11, _toDisplayString(currentExploration.value.applyname), 1),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "label" }, "证件号码", -1)),
              _createElementVNode("td", _hoisted_12, _toDisplayString(currentExploration.value.applyCardnumber), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "label" }, "法人姓名", -1)),
              _createElementVNode("td", _hoisted_13, _toDisplayString(currentExploration.value.legalman), 1),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "label" }, "法人电话", -1)),
              _createElementVNode("td", _hoisted_14, _toDisplayString(currentExploration.value.applyTelephone), 1),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "label" }, "法人证件号码", -1)),
              _createElementVNode("td", _hoisted_15, _toDisplayString(currentExploration.value.applyIdCard), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[14] || (_cache[14] = _createElementVNode("td", { class: "label" }, "联系人姓名", -1)),
              _createElementVNode("td", _hoisted_16, _toDisplayString(currentExploration.value.contactman), 1),
              _cache[15] || (_cache[15] = _createElementVNode("td", { class: "label" }, "联系人电话", -1)),
              _createElementVNode("td", _hoisted_17, _toDisplayString(currentExploration.value.telphone), 1),
              _cache[16] || (_cache[16] = _createElementVNode("td", { class: "label" }, "联系人证件号码", -1)),
              _createElementVNode("td", _hoisted_18, _toDisplayString(currentExploration.value.contactmanCardnumber), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "label" }, "事项编码", -1)),
              _createElementVNode("td", _hoisted_19, _toDisplayString(currentExploration.value.servicecode), 1),
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "label" }, "事项名称", -1)),
              _createElementVNode("td", _hoisted_20, _toDisplayString(currentExploration.value.servicename), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "label" }, "房间号", -1)),
              _createElementVNode("td", _hoisted_21, _toDisplayString(currentExploration.value.roomId), 1),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "label" }, "预约时间", -1)),
              _createElementVNode("td", _hoisted_22, _toDisplayString(currentExploration.value.appointmentTime), 1),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "label" }, "审批人", -1)),
              _createElementVNode("td", _hoisted_23, _toDisplayString(currentExploration.value.realName), 1)
            ]),
            _createElementVNode("tr", null, [
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "label" }, "地址", -1)),
              _createElementVNode("td", _hoisted_24, _toDisplayString(currentExploration.value.address), 1)
            ])
          ]),
          _createVNode(_component_el_alert, {
            title: "温馨提示",
            type: "success",
            description: `您已成功申请零跑智勘，请关注中国（河南）自由贸易试验区开封片区公众号，点击公众号办事指引里零跑智勘进行登录，输入申报时所填的统一信用代码和法人手机号进行登录勘探，你的勘探验证码为${currentExploration.value.roomId}`,
            "show-icon": "",
            closable: false
          }, null, 8, ["description"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})